import { request } from '@/api/apiUtils';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { IFountainFragment, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const FOUNTAIN_FRAGMENTS_ROOT = ['fountain', 'fragments'] as const;

interface FragmentsListParams {
    projectId: number;
    version?: string;
}

const fetchers = {
    list: {
        key: ({ projectId, version }: FragmentsListParams) =>
            [...FOUNTAIN_FRAGMENTS_ROOT, version !== undefined ? { projectId, version } : { projectId }] as const,
        fetch: async ({ projectId, version }: FragmentsListParams): Promise<IFountainFragment[]> => {
            const params = new URLSearchParams();
            params.append('with', 'text_atoms');
            params.append('with', 'tags.subject');
            if (version) params.append('version', version);
            const data: ResponseType<IFountainFragment[]> = await request(`projects/${projectId}/fragments?${params}`);
            return data.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const fragmentsEntity: EntityDefinition<typeof fetchers> = {
    name: 'fragments',
    roots: [FOUNTAIN_FRAGMENTS_ROOT],
    fetchers,
};

export type { FragmentsListParams };
